import DefaultLink from 'components/common/DefaultLink';
import Text from 'components/common/Text';

import AddToOrderButton from './AddToOrderButton';

const MealCard = ({
  servings = 0,
  meal,
  removeServing,
  removeMeal,
  addServing,
  disabled = false,
}) => {
  const formatURL = slug => {
    return `/meals/${slug}?pick_meals=true`;
  };

  const SoldOutMealWarning = () => {
    return (
      <div className="h-14 w-full content-center bg-red-50 text-center">
        <Text htmlElement="span" className="textMd text-red-100">
          Sold Out
        </Text>
      </div>
    );
  };

  return (
    <>
      <div className="mb-4 flex bp2:mb-0 bp2:pb-4 bp2:pr-2 bp3:pr-3">
        <article className="w-sm relative flex min-h-full max-w-sm flex-col items-stretch rounded text-left shadow-md transition-all duration-200 hover:shadow-xl">
          <div className="relative flex h-full flex-col items-stretch bg-white-100 text-left transition-all duration-200">
            <DefaultLink
              className="flex h-full flex-col no-underline"
              isExternal
              to={formatURL(meal.slug)}
            >
              <div className="rounded-md">
                <img
                  className="bg-white min-w-md relative flex flex-col items-stretch rounded-t text-left"
                  alt={meal.title}
                  src={meal.photoUrl}
                />
              </div>
              <div className="flex h-full flex-col p-4 text-left">
                <Text brandStylesOverrides="h6" className="m-0 text-tempo-black-100">
                  {meal.title}
                </Text>
                <Text className="bp1:mt-0.5">{meal.subtitle}</Text>
                <Text brandStylesOverrides="textSm" className="no-content-after mt-1 lowercase">
                  {meal.cookTime} min
                </Text>

                <ul className="mt-4 flex flex-row flex-wrap gap-2 rounded">
                  {meal.mealLabels.map((label, index) => (
                    <li key={index} className="inline-block list-none">
                      <span className="card__label h7 bg-charcoal-50 text-charcoal-100">
                        {label}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </DefaultLink>
            {meal.isSoldOut ? (
              <SoldOutMealWarning />
            ) : (
              <AddToOrderButton
                meal={meal}
                servings={servings}
                removeMeal={removeMeal}
                removeServing={removeServing}
                addServing={addServing}
                disabled={disabled}
              />
            )}
          </div>
        </article>
      </div>
    </>
  );
};

MealCard.propTypes = {
  meal: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    photoUrl: PropTypes.string.isRequired,
    cookTime: PropTypes.string.isRequired,
    mealLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
    isSoldOut: PropTypes.bool.isRequired,
  }).isRequired,
  removeMeal: PropTypes.func.isRequired,
  removeServing: PropTypes.func.isRequired,
  addServing: PropTypes.func.isRequired,
  servings: PropTypes.number,
  disabled: PropTypes.bool,
};

export default MealCard;
